export const safeStringify = <T>(value: T, fallbackValue: string = '') => {
    try {
        return JSON.stringify(value);
    } catch {
        return fallbackValue;
    }
};
